import { Sorted } from '@features/reporting/hooks/useSort'
import { infoByColumnId } from '@features/reporting/lib/infoByColumnId'
import { ReportTypeMap } from '@features/reporting/types'
import { convertToSortApiColumn } from '@features/reporting/utils/convertToApiSortColumn'
import { filterToDotSnakeCase } from '@features/reporting/utils/filterToDotSnakeCase'
import { ReportFilter } from '@lib/api'
import { toDotSnakeCase } from '@utils/toDotSnakeCase'

interface Options<RT extends keyof ReportTypeMap> {
  type: RT
  columnIds: ReportTypeMap[RT]['columnId'][]
  filterParams: ReportFilter<RT>
  sorted: Sorted
}

export const toApiParams = <RT extends keyof ReportTypeMap>({
  type,
  columnIds,
  filterParams,
  sorted,
}: Options<RT>) => {
  if (type === 'audit_log')
    return {
      apiColumns: [],
      apiFilters: [],
      apiSortColumn: null,
    }

  return {
    apiColumns: columnIds.map(
      (id) => infoByColumnId({ reportType: type, id }).snakeCaseAccessorKey,
    ),
    apiFilters: filterToDotSnakeCase(filterParams),
    apiSortColumn: toDotSnakeCase(convertToSortApiColumn(type, sorted.column)),
  }
}
